import * as React from 'react';

const Tag = ({ children, type = 'primary', className = '' }) => (
  <span className={`tag is-${type} ${className}`}>{children}</span>
);

export default Tag;
